import logo from './Fallback.svg';

const Fallback = () => {
    return (
        <img src={logo} alt="Generic bank logo" data-testid="fallback-logo" />
    );
};

Fallback.borderColor = '#0C2340';
Fallback.textColor = '#0C2340';

// eslint-disable-next-line import/no-default-export
export default Fallback;
